import React from "react";

export default function OurStory() {
  return (
    <div data-testid="our-story-page">
      <section className="sd-page-hero">
        <h1>Our Story</h1>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          <img
            src="/images/ourstory.jpg"
            alt="Our Story"
            className="w-full rounded shadow-lg"
          />
          <div>
            <h2 className="text-[#cd0202] text-3xl mb-4 font-display">
              40+ Years of Tradition
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              For over 40 years the Milani Family has owned and operated the
              first and only Sub Shop in Lockport. What began as a small
              neighborhood deli has grown into a Lockport institution — and
              we're just getting started.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Every roll is baked fresh, every meat is sliced to order, and
              every sauce is made from a Milani family recipe passed down
              through three generations.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Today, with our second location now open on Rochester Rd., we're
              proud to enter another 40 years of serving the community we love.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#2d8a86] py-16 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl mb-4 font-display">Our Promise</h2>
          <p className="text-lg max-w-2xl mx-auto">
            100% USDA quality meats, fresh produce delivered daily, and the
            same family recipes that have kept Lockport coming back since 1985.
          </p>
        </div>
      </section>
    </div>
  );
}
